import { render, staticRenderFns } from "./otherIncomeWagesList.vue?vue&type=template&id=4be87d89&scoped=true&"
import script from "./otherIncomeWagesList.vue?vue&type=script&lang=js&"
export * from "./otherIncomeWagesList.vue?vue&type=script&lang=js&"
import style0 from "./otherIncomeWagesList.vue?vue&type=style&index=0&id=4be87d89&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be87d89",
  null
  
)

export default component.exports